module.exports = __webpack_public_path__ + "01_long_gold.852ff78e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/01_long_gold.png
// module id = ge0Q
// module chunks = 0